export default {
  app: {
    name: 'Beijing Zhongchi Law Firm',
    lang: 'en',
    title: 'Beijing Zhongchi Law Firm'
  },

  nav: {
    home: 'HOME',
    home_en: '',
    about: 'ABOUT US',
    about_en: '',
    service: 'SERVICE',
    service_en: '',
    team: 'TEAM',
    team_en: '',
    activity: 'ACTIVITY',
    activity_en: '',
    invite: 'INVITE',
    invite_en: '',
    contact: 'CONTACT',
    contact_en: ''
  },

  sections: {
    services: 'SERVICES',
    team: 'TEAM',
    introduction: 'INTRODUCTION',
    news: 'NEWS'
  },

  messages: {
    hello: 'Welcome to Beijing Zhongchi Law Firm',
    details: 'DETAILS',
    more: 'MORE',
    more_lawyers: 'MORE LAWYERS',
    more_introduction: 'MORE INTRODUCTION',
    page_location: 'Location:',
    contact_form: {
      title: 'Appointment for legal consultation/case agency',
      name: 'Name',
      name_ph: 'Please input your name',
      mobile: 'Phone',
      mobile_ph: 'Please input your phone number',
      address: 'Address',
      address_ph: 'Please input your address',
      content: 'Content',
      content_ph: 'Please briefly state the case',
      submit: 'Submit'
    }
  },

  breadcrumb: {
    home: 'Home',
    about: 'About us',
    service: 'Service',
    team: 'Team',
    activity: 'Activity',
    invite: 'Invite',
    contact: 'Contact'
  },

  about: {
    name: 'About us',
    home_content: `
      <p>
        Beijing Zhongchi Law Firm is a comprehensive law firm located in Chongwenmen, Dongcheng District, the core area of Beijing. It aims to provide high-quality legal services for all regions, industries, and fields across the country, including criminal cases and marriages. Family affairs, creditor's rights and debts, contract disputes, real estate disputes, share disputes, non-litigation services, corporate legal advisory services, etc.
      </p>
    `,
    content: `
      <p>
        Beijing Zhongchi Law Firm is a comprehensive law firm located in Chongwenmen, Dongcheng District, the core area of Beijing. It aims to provide high-quality legal services for all regions, industries, and fields across the country, including criminal cases and marriages. Family affairs, creditor's rights and debts, contract disputes, real estate disputes, share disputes, non-litigation services, corporate legal advisory services, etc.
      </p>

      <p>
        The headquarters of the law firm is located on the 7th, 11th floor of Building B, Chongwenmen New World Center Office Building, Dongcheng District, Beijing's core functional area, adjacent to Beijing Railway Station, Metro Line 2 and Line 5 Chongwenmen Metro Station, and the transportation is extremely convenient. The office environment of the law firm is beautiful, with an office area of nearly 300 square meters.
      </p>

      <p>
        Beijing Zhongchi Law Firm was established and founded by lawyer Zhao Ziyong. The purpose of the office is to better serve the society and help more people enjoy high-quality and convenient legal services. The law firm’s practice philosophy is “Serve the people’s lives and safeguard social fairness and justice”, and is trained to “be a lawyer who is beneficial to the society and the people” and serve the clients’ legitimate rights and interests wholeheartedly. The law firm adheres to social welfare undertakings and established Zhongchi Lawyers' Multi-mediation Room-Zhongchi Law Firm's Civil Dispute Resolution Center, which actively participates in my country's diversified dispute resolution mechanism and builds a harmonious socialist society. Zhongchi's lawyers team uphold fairness, uphold justice, try their best to handle cases, treat each client with care, and have a good reputation and reputation.
      </p>

      <p>
        Zhongchi lawyer, well-known at home and abroad, is worthy of your trust!
      </p>
    `
  },
  service: {
    name: 'SERVICE',
    criminal_case: 'CRIMINAL CASE',
    criminal_case_en: '',
    criminal_case_desc: 'Criminal interview, bail pending trial, etc.',
    contract_dispute: 'CONTRACT DISPUTE',
    contract_dispute_en: '',
    contract_dispute_desc: '',
    family_affairs: 'MARRIAGE/FAMILY AFFAIRS',
    family_affairs_en: '',
    family_affairs_desc: '',
    debt_dispute: 'DEBT DISPUTE',
    debt_dispute_en: '',
    debt_dispute_desc: '',
    intellectual_property: 'INTELLECTUAL PROPERTY',
    intellectual_property_en: '',
    intellectual_property_desc: '',
    enterprise_legal: 'ENTERPRISE LEGAL SERVICES',
    enterprise_legal_en: '',
    enterprise_legal_desc: '',
    non_litigation: 'NON-LITIGATION SERVICES',
    non_litigation_en: '',
    non_litigation_desc: '',
    other: 'OTHER SERVICES',
    other_en: '',
    other_desc: ''
  },
  activity: {
    name: 'Activity',
    news: 'News',
    legal: 'Knowledge',
    search: 'Input title to search',
    publish_time: 'Publish time',
    view_count: 'View count'
  },
  invite: {
    name: 'Invite'
  },
  contact: {
    name: 'Contact us',
    content: `
      <h4 class="color-primary with-left-primary-color-bar">Contact information</h4>
      <p>
        <span>Phone:</span>
        <span>010-67665196</span>
      </p>
      <p>
        <span>Phone:</span>
        <span>13910962198</span>
      </p>
      <p>
        <span>Email:</span>
        <span>13910962198@139.com</span>
      </p>
      <p>
        <span>Address:</span>
        <span>11F, Block B, New World Center Office Building, No. 3, Chongwenmenwai Street, Dongcheng District, Beijing</span>
      </p>
      <p>
        <span>Transportation:</span>
        <span>Beijing Metro Line 2/5 Chongwenmen Station H Southwest Gate</span>
      </p>
    `
  },

  footer: {
    quick: 'Quick entry',
    contact: 'Contact us',
    address:
      '11F, Block B, New World Center Office Building, No. 3, Chongwenmenwai Street, Dongcheng District, Beijing',
    code: `Scan the QR code to follow Zhongchi's official account`,
    copyright: 'Copyright ©Beijing Zhongchi Law Firm  All rights reserved'
  }
}
